var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.332 5.756a.818.818 0 0 1-1.636 0m1.636 0a.818.818 0 0 0-1.636 0m1.636 0h-1.636M16.612 2H7.388A5.388 5.388 0 0 0 2 7.388v9.224A5.388 5.388 0 0 0 7.389 22h9.222A5.389 5.389 0 0 0 22 16.611V7.388A5.388 5.388 0 0 0 16.612 2Zm.216 10a4.828 4.828 0 1 1-9.656 0 4.828 4.828 0 0 1 9.656 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramLine);
export default __webpack_public_path__ + "static/media/instagram_line.44f9912e894290f9b1d022e5076c3052.svg";
export { ForwardRef as ReactComponent };